import { ApiMethods, ApiTags, appAPI } from '.';
import { OnboardingStatus } from '../../entities/OnboardingStatus';
import { notify } from '../../clients/ApiService';

interface PatchDismissalStateParams {
  fields: Partial<OnboardingStatus['fields']>;
}

export const improvedOnboardingApi = appAPI.injectEndpoints({
  endpoints: build => ({
    patchDismissalState: build.mutation<
      OnboardingStatus,
      PatchDismissalStateParams
    >({
      query: entity => ({
        path: `/onboarding-task-status`,
        method: ApiMethods.patch,
        options: {
          body: {
            ...entity,
          },
        },
      }),
      async onQueryStarted(input, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          improvedOnboardingApi.util.updateQueryData(
            'getOnboardingTaskStatus',
            undefined,
            draft => {
              // eslint-disable-next-line no-param-reassign
              draft.fields.dismissed = Boolean(input.fields.dismissed);
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch (error) {
          // if there is an error, we need to revert the state
          patch.undo();
          notify({
            status: 'error',
            errorMessage: `Card can not be \`${
              input.fields.dismissed ? 'dismissed' : 'un-dismissed'
            }\``,
            error,
            dispatch,
          });
        }
      },
    }),
    getOnboardingTaskStatus: build.query<OnboardingStatus, void>({
      query: () => ({
        path: '/onboarding-task-status',
        method: ApiMethods.get,
        options: {},
      }),
      providesTags: [ApiTags.onboarding_task_status],
    }),
  }),
});

export const {
  usePatchDismissalStateMutation,
  useGetOnboardingTaskStatusQuery,
} = improvedOnboardingApi;
